import tw from "twin.macro";

function SkeletonRow({ isLast }: { isLast: boolean }) {
  return (
    <div
      css={[
        tw`flex items-center gap-3 px-2 py-3`,
        !isLast && tw`border-b border-gray-200`,
      ]}
    >
      <div css={tw`w-10 h-10 rounded-full bg-gray-200 shrink-0`} />
      <div css={tw`h-4 w-28 bg-gray-200 rounded`} />
      <div css={tw`ml-auto h-5 w-16 bg-gray-200 rounded-full`} />
    </div>
  );
}

function SkeletonSection({ rows }: { rows: number }) {
  return (
    <div css={tw`flex flex-col`}>
      <div css={tw`h-3 w-32 bg-gray-200 rounded mx-2 mb-2 mt-1`} />
      <div css={tw`rounded-xl border overflow-hidden`}>
        {Array.from({ length: rows }).map((_, i) => (
          <SkeletonRow key={i} isLast={i === rows - 1} />
        ))}
      </div>
    </div>
  );
}

export default function ProtectionListSkeleton({
  sections,
}: {
  sections: number[];
}) {
  return (
    <div css={tw`flex flex-col gap-4 px-4 pb-6 animate-pulse`}>
      {sections.map((rows, i) => (
        <SkeletonSection key={i} rows={rows} />
      ))}
    </div>
  );
}
